/** Formata data ISO (`yyyy-MM-dd`) para exibição (`dd/MM/yyyy`). */
export function formatDateIsoToBr(isoDate: string): string {
  if (!isoDate) {
    return '';
  }

  const [year, month, day] = isoDate.split('-');
  if (!year || !month || !day) {
    return isoDate;
  }

  return `${day}/${month}/${year}`;
}

/**
 * Extrai a data (`yyyy-MM-dd`) de um ISO que pode vir com hora (`yyyy-MM-ddTHH:mm:ss.sssZ`).
 * O corte é textual de propósito: converter para `Date` deslocaria o dia pelo fuso do navegador
 * e faria a integração aparecer no dia anterior.
 */
export function extractIsoDate(isoDateTime?: string | null): string {
  return isoDateTime?.split('T')[0] ?? '';
}

/**
 * Formata um ISO com hora para `yyyy-MM-dd HH:mm`, como o log do participante exibe. O corte é
 * textual pelo mesmo motivo de `extractIsoDate`: converter para `Date` deslocaria data e hora
 * pelo fuso do navegador.
 */
export function formatIsoDateTime(isoDateTime?: string | null): string {
  const [data, hora] = (isoDateTime ?? '').split('T');

  if (!data || !hora) {
    return data ?? '';
  }

  return `${data} ${hora.slice(0, 5)}`;
}
